import type { TutorialMode, TutorialStepId } from '../profile/schema';

export type TutorialEvent =
  | { readonly kind: 'open' }
  | { readonly kind: 'catch'; readonly first: boolean }
  | { readonly kind: 'target' }
  | { readonly kind: 'destination' }
  | { readonly kind: 'away' }
  | { readonly kind: 'arrival' }
  | { readonly kind: 'return' };

const STEPS: readonly TutorialStepId[] = ['watch-autonomy', 'first-catch', 'choose-quarry', 'choose-ground', 'away-progress', 'arrival', 'next-course'];
const EVENT_FOR: Readonly<Record<TutorialStepId, TutorialEvent['kind']>> = {
  'watch-autonomy': 'open', 'first-catch': 'catch', 'choose-quarry': 'target', 'choose-ground': 'destination', 'away-progress': 'away', arrival: 'arrival', 'next-course': 'return',
};

function nextStep(step: TutorialStepId): TutorialMode {
  const index = STEPS.indexOf(step);
  const following = STEPS[index + 1];
  return following === undefined ? { kind: 'completed' } : { kind: 'active', stepId: following };
}

export function advanceTutorial(mode: TutorialMode, event: TutorialEvent): TutorialMode {
  if (mode.kind === 'unseen' && event.kind === 'open') return { kind: 'offered' };
  if (mode.kind === 'offered' && event.kind === 'open') return { kind: 'active', stepId: 'watch-autonomy' };
  if ((mode.kind === 'active' || mode.kind === 'replay') && EVENT_FOR[mode.stepId] === event.kind && (event.kind !== 'catch' || event.first)) return nextStep(mode.stepId);
  return mode;
}

export function skipTutorial(mode: TutorialMode, all: boolean): TutorialMode {
  if (all) return { kind: 'skipped' };
  return mode.kind === 'active' || mode.kind === 'replay' ? nextStep(mode.stepId) : mode;
}

export function replayTutorial(stepId: TutorialStepId): TutorialMode { return { kind: 'replay', stepId }; }
